export default __webpack_public_path__ + "static/media/webapplicationimg1.b79e7d27.png";